"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailableFromAvailabilitySchedule = exports.isAvailableFromDate = exports.TickeatCatalogHelpers = void 0;
exports.isProductDisabled = isProductDisabled;
exports.isProductOutOfStock = isProductOutOfStock;
exports.isProductVariationOutOfStock = isProductVariationOutOfStock;
exports.isPackOutOfStock = isPackOutOfStock;
const ordering_1 = require("@tickeat/ordering");
class TickeatCatalogHelpers {
    static getCatalogToProduct(productId, catalogToProducts) {
        return catalogToProducts.find(catalogToProduct => catalogToProduct.productId === productId);
    }
    static getProductVariationLoyaltyPointOffered(productVariation, catalogProductToProductVariations) {
        const catalogProductToProductVariation = catalogProductToProductVariations?.find(catalogProductToProductVariation => catalogProductToProductVariation.productVariationId === productVariation._id);
        return catalogProductToProductVariation?.loyaltyPointOffered ?? productVariation?.loyaltyPointOffered;
    }
    static getPackLoyaltyPointOffered(pack, catalogToPacks) {
        const catalogToPack = catalogToPacks?.find(catalogToPack => catalogToPack.packId === pack._id);
        return catalogToPack?.loyaltyPointOffered ?? pack?.loyaltyPointOffered;
    }
    static getProductVariationPrice(priceKey, productVariation, catalogProductToProductVariations) {
        const catalogProductToProductVariation = catalogProductToProductVariations?.find(catalogProductToProductVariation => catalogProductToProductVariation.productVariationId === productVariation._id);
        return catalogProductToProductVariation?.[priceKey] ?? catalogProductToProductVariation?.price ?? productVariation?.[priceKey] ?? productVariation.price;
    }
    static getPackPrice(priceKey, pack, catalogToPacks) {
        const catalogToPack = catalogToPacks?.find(catalogToPack => catalogToPack.packId === pack._id);
        return catalogToPack?.[priceKey] ?? catalogToPack?.price ?? pack?.[priceKey] ?? pack.price;
    }
    static isPackDisabled(pack, catalogToPacks) {
        const catalogToPack = catalogToPacks?.find(catalogToPack => catalogToPack.packId === pack._id);
        return Boolean(catalogToPack?.disabled ?? pack.disabled);
    }
    static isPromotionDisabled(promotion, catalogToPromotions) {
        const catalogToPromotion = catalogToPromotions?.find(catalogToPromotion => catalogToPromotion.promotionId === promotion._id);
        return Boolean(catalogToPromotion?.disabled ?? promotion.disabled);
    }
    static isProductDisabled(product, catalogToProducts) {
        const catalogToProduct = catalogToProducts?.find(catalogToProduct => catalogToProduct.productId === product._id);
        return Boolean(catalogToProduct?.disabled ?? product.disabled);
    }
    static isProductVariationDisabled(product, productVariation, catalogToProducts) {
        const catalogToProduct = catalogToProducts?.find(catalogToProduct => catalogToProduct.productId === product._id);
        const catalogProductToProductVariation = catalogToProduct?.catalogProductToProductVariations?.find(catalogProductToProductVariation => catalogProductToProductVariation.productVariationId === productVariation._id);
        const isProductDisabled = TickeatCatalogHelpers.isProductDisabled(product, catalogToProducts);
        const isProductVariationDisabled = Boolean(catalogProductToProductVariation?.disabled ?? productVariation.disabled);
        return isProductDisabled || isProductVariationDisabled;
    }
}
exports.TickeatCatalogHelpers = TickeatCatalogHelpers;
const isAvailableFromDate = (item, date) => {
    const startOk = !item.startDate || new Date(item.startDate) < date;
    const endOk = !item.endDate || new Date(item.endDate) > date;
    return startOk && endOk;
};
exports.isAvailableFromDate = isAvailableFromDate;
const isAvailableFromAvailabilitySchedule = (item, instantIso, timezone = 'Europe/Paris') => {
    // Court-circuit : aucune plage sur aucun jour ne restreint rien (la règle
    // d'ordering le dit aussi) — la carte entière passe ici, sans payer un
    // `Intl.DateTimeFormat` par article sans horaires.
    if (sansAucunePlage(item?.availabilitySchedule))
        return true;
    return (0, ordering_1.estDisponibleA)(item?.availabilitySchedule, instantIso ?? new Date().toISOString(), timezone);
};
exports.isAvailableFromAvailabilitySchedule = isAvailableFromAvailabilitySchedule;
// Horaire absent, `{}` ou sept jours vides : aucune restriction.
function sansAucunePlage(schedule) {
    return schedule === null || schedule === undefined || Object.values(schedule).every((plages) => (plages ?? []).length === 0);
}
function isProductDisabled(product) {
    return product.disabled || product.productVariations.length === 0;
}
function isProductOutOfStock(product, ingredientsOutOfStockIds) {
    const outOfStockVariations = product.productVariations.filter(productVariation => isProductVariationOutOfStock(productVariation, ingredientsOutOfStockIds));
    return outOfStockVariations.length > 0 && outOfStockVariations.length === product.productVariations.length;
}
function isProductVariationOutOfStock(productVariation, ingredientsOutOfStockIds) {
    return !!productVariation?.productVariationToIngredients
        .map(productVariationToIngredient => productVariationToIngredient.ingredientId)
        ?.find(id => ingredientsOutOfStockIds.find(ingredientId => id === ingredientId));
}
function isPackOutOfStock(pack, ingredientsOutOfStockIds) {
    const packToStepsMandatory = pack.packToSteps.filter(packToStep => packToStep.step?.mandatory);
    const hasPackToProductVariationsUnavailable = pack.packToProductVariations.some(packToProductVariation => isProductVariationOutOfStock(packToProductVariation.productVariation, ingredientsOutOfStockIds));
    if (hasPackToProductVariationsUnavailable) {
        return true;
    }
    const packToStepsAvailable = packToStepsMandatory.filter(packToStep => {
        const stepToProductVariationsFiltered = packToStep.step?.stepToProductVariations.filter(stepToProductVariation => !isProductVariationOutOfStock(stepToProductVariation.productVariation, ingredientsOutOfStockIds));
        return !!stepToProductVariationsFiltered?.length;
    });
    return packToStepsMandatory.length !== packToStepsAvailable.length;
}
